<template>
    <div class="Admin_Dashboard__wrap">
        <v-toolbar color="#414042" dark flat class="header">
        <v-toolbar-title>
            <v-icon class="mdi mdi-heart mr-1 admin-primary-icon"/> 관리자 대시보드
        </v-toolbar-title>

        <AdminAccessor :count="count"/>

        <v-spacer></v-spacer>


        <v-btn icon elevation="0" @click="exitBtn"><v-icon class="mdi mdi-logout" /></v-btn>

        <template v-slot:extension>
            <v-tabs
            v-model="currentItem"
            fixed-tabs
            slider-color="white"
            >
                <v-tab :href="'#tab-Item1'">참가자 정보 조회</v-tab>
                <v-tab :href="'#tab-Item2'">실시간 질문 목록</v-tab>
                <v-tab :href="'#tab-Item3'">다시보기 통계</v-tab>
            </v-tabs>
        </template>
        </v-toolbar>

        <v-tabs-items v-model="currentItem" class="Admin_Dashboard__tabitem">
            <AdminUserData :loading="loading" :reloadUserData="reloadUserData" :load="load" :userList="userList" v-if="currentItem === 'tab-Item1'" @download-Btn="download"/>
            <AdminQuestionList :qnaList="qnaList" v-if="loadQna && currentItem === 'tab-Item2'" />
            <AdminVodStats
                v-if="currentItem === 'tab-Item3'"
                :items="vodStats"
                :loading="vodLoading"
                :reload="fetchVodStats"
            />
        </v-tabs-items>

        <v-footer class="Admin_Dashboard__footer">
            <span>한국지질동맹경화학회 - 제 14회 A to Z 연수강좌 Atherosclearosis to Zero</span>
        </v-footer>
    </div>
    
</template>

<script>
import AdminAccessor from '@/components/admin/AdminAccessor.vue';
import AdminUserData from '@/components/admin/AdminUserData.vue';
import AdminQuestionList from '@/components/admin/AdminQuestionList.vue';
import AdminVodStats from '@/components/admin/AdminVodStats.vue';
import { mapActions } from 'vuex';
import AdminApi from '@/api/admin/AdminApi';
import _ from 'lodash';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
    components: {
        AdminUserData,
        AdminQuestionList,
        AdminAccessor,
        AdminVodStats,
    },
    data: () => ({
        currentItem: 'tab-Item1',
        userList: [],
        qnaList: [],
        sessionList: [],
        load: false,
        loadQna: false,
        loading: false,
        count: 0,
        vodStats: [],
        vodLoading: false,
        // intervalRunning: false,
        // interval: null,
    }),

    mounted() {
        this.fetchUserList();
        this.fetchQnAist();
        this.fetchStat();
        this.fetchVodStats();
        const savedTab = localStorage.getItem("currentTab");
        if (savedTab) {
            this.currentItem = savedTab;
        }
        // this.fetchSessionList();
        // this.fetchSessionQnaList();
    },
    
    beforeDestroy(){
        // if(this.interval){
        //     clearInterval(this.interval);
        // }
    },
    computed: {
        // sessionArray(){
        //     if(this.load){
        //         return this.sessionList.map(e => e);
        //     }
        // }
    },

    watch: {
        qnaList: _.debounce(function(newVal, oldVal) {
            if (this.currentItem === 'tab-Item2') {
                this.reloadQnAData();    
            }
        }, 10000),

        currentItem: {
            async handler(newValue, oldValue) {
                localStorage.setItem("currentTab", newValue);
                if (newValue !== oldValue) {
                    return newValue;
                }
            },
            mmediate: true,
            deep: true 
        },

        count: _.debounce(function(newVal, oldVal) {
            this.fetchStat();
        }, 10 * 60 * 1000),
    },
    methods: {
        ...mapActions('admin', ['logout']),
        exitBtn(){
            this.logout()
                .then(() => {
                    this.$router.push({ path: '/admin' });
                })
                .catch(error => {
                    console.error('Logout error:', error);
                });
        },
        async fetchUserList(){
            try {
                this.loading = true;
                const response = await AdminApi.userListApi();
                this.load = true;
                this.userList = response.map(e => e);
                // console.log("this.userList => ", this.userList);
            } catch (error) {
                console.error("Error fetching userList:", error);
            } finally {
                this.loading = false;
            }
        },
        // async fetchSessionList(){
        //     try {
        //         const response = await AdminApi.sessionListApi();
        //         this.load = true;
        //         this.sessionList = response.map(e => e);

        //     } catch (error) {
        //         console.error("Error fetching sessionList:", error);
        //     }
        // },
        async fetchSessionQnaList(){
            try {
                const response = await AdminApi.sessionQnaListApi();
                this.load = true;
                this.sessionList = response.map(e => e);

            } catch (error) {
                console.error("Error fetching sessionList:", error);
            }
        },
        async fetchStat(){
            try {
                const response = await AdminApi.statApi();
                if(response){
                    this.count = Object.values(response)[0];
                    // console.log("count => ", this.count)
                }
            } catch (error) {
                console.error("Error fetching fetchStat:", error);
            }
        },
        async fetchVodStats(){
            this.vodLoading = true;
            try {
                const response = await AdminApi.vodStatsApi();
                this.vodStats = Array.isArray(response) ? response : [];
            } catch (error) {
                console.error("Error fetching VOD stats:", error);
            } finally {
                this.vodLoading = false;
            }
        },
        reloadUserData(){
            this.fetchUserList();
        },
        reloadQnAData(){
            this.fetchQnAist();
        },
        async fetchQnAist(){
            try {
                // this.intervalRunning = true;
                const response = await AdminApi.qnaApi();
                this.loadQna = true;
                this.qnaList = response.map(e => e);
                // this.speakerList = response.
                // console.log("this.qnaList => ", this.qnaList);
            } catch (error) {
                console.error("Error fetching qnaList:", error);
            } 
            // finally {
            //     this.intervalRunning = false;
            // }
        },
        async download(){
            try {
                const response = await AdminApi.downloadApi();
                // const data = Array.isArray(response[0]) ? response[0] : response;
                const data = response.flatMap(e => e);
                
                const worksheet = XLSX.utils.json_to_sheet(data);

                worksheet['!cols'] = [
                    { wch: 10 }, 
                    { wch: 13 }, 
                    { wch: 20 }, 
                    { wch: 13 },
                ];

                worksheet['!rows'] = Array(data.length + 1).fill({ hpt: 15 });

                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, '사용자접속기록');

                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
                saveAs(blob, 'users_log.xlsx');


                // // csv ver
                // const csvContent = this.convertToCSV(data);
                // const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

                // const link = document.createElement('a');
                // const url = URL.createObjectURL(blob);

                // link.setAttribute('href', url);
                // link.setAttribute('download', 'users_log.csv');
                // link.style.visibility = 'hidden';

                // document.body.appendChild(link);
                // link.click();
                // document.body.removeChild(link);


            } catch (error) {
                console.error("Error download:", error);
            }
        },
        convertToCSV(objArray) {
            const array = Array.isArray(objArray) ? objArray : [objArray];
            const headers = Object.keys(array[0]).join(',');
            const rows = array.map(row => Object.values(row).join(','));
            return [headers, ...rows].join('\n');
        }
    },
}
</script>

<style scoped>
.header { position: fixed; width: 100%; top: 0;z-index: 3; }
</style>
